import {h, Component} from 'preact';
import {parseCurrency} from 'helpers';


class AddToCart extends Component {
	state = {
		tickets: []
	}
	componentDidMount(){
		console.log(this.props.tickets);
		this.setState({
			tickets: (this.props.tickets || []).map(ticket => {
				ticket.maxQuantity = ticket.maxQuantity || ticket.quantity;
				if(!this.props.cart) ticket.quantity = 0;
				return ticket
			})
		})
		document.body.classList.add('modal-open');
	}
	componentWillUnmount(){
		document.body.classList.remove('modal-open')
	}
	generateOptions = (length = 10, maxQuantity) => {
		const fullLength = maxQuantity ? Math.min(Math.max(length,10),maxQuantity) : Math.max(length,10);
		return Array.from({length:fullLength + 1}).map((a,i) => <option value={i}>{i}</option>)
	}
	addToCart = (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		const items = this.props.tickets.reduce((final,item) => {
			item.quantity = parseInt(item.quantity) || 0;

			if(item.quantity) {
				return [...final, item];
			} else {
				return final;
			}
		}, []);

		this.props.onChange(items);
	}
	render(props,state) {
		return <div>
			<div class="modal-backdrop fade show" />
			<div class="modal fade show" id="contact-box-modal" tabindex="-1" role="dialog" aria-modal="true" style="display: block;">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content bg-light">
						<div class="modal-body">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
								<svg class="icon bg-dark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z" fill="#212529"></path>
									<path d="M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z" fill="#212529"></path>
								</svg>
							</button>
							<div class="m-3">
								<h3>Ostoskori</h3>
								<form action="/" data-form-email="" novalidate="">
									{state.tickets.map((ticket, index, tickets) =>
										<div href="#" class="card card-body hover-shadow-sm p-2">
											<div class="d-flex justify-content-between align-items-center">
												<div>
													<div class="mb-2">
														<span class="badge bg-primary-alt text-primary">
															{ticket.tag}
														</span>
													</div>
													<h4 class="mb-2">{ticket.title}</h4>
													<span>{parseCurrency(ticket.price)}</span>
												</div>
												<div class="form-group mb-lg-0">
													<select class="custom-select custom-select-lg bg-white mr-4" value={ticket.quantity || 0} onChange={e => {ticket.quantity = parseInt(e.target.value);this.setState({tickets})}}>
														{this.generateOptions(ticket.quantity, ticket.maxQuantity)}
													</select>
													<svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M14.4444 8.41358C14.7776 8.2281 15.1875 8.46907 15.1875 8.85048V15.1495C15.1875 15.5309 14.7776 15.7719 14.4444 15.5864L8.78505 12.4369C8.44258 12.2463 8.44258 11.7537 8.78505 11.5631L14.4444 8.41358Z" fill="#212529"></path>
													</svg>
												</div>
											</div>
										</div>
									)}
									<button type="submit" onClick={this.addToCart} class={(state.tickets || []).reduce((sum,item) => sum+(item.quantity||0) ,0) > 0? "btn btn-block btn-success" : "btn btn-block"} data-loading-text="Sending">
										<svg class="icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Icon For Heart</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect opacity="0" x="0" y="0" width="24" height="24"></rect><path d="M18.1446364,11.84388 L17.4471627,16.0287218 C17.4463569,16.0335568 17.4455155,16.0383857 17.4446387,16.0432083 C17.345843,16.5865846 16.8252597,16.9469884 16.2818833,16.8481927 L4.91303792,14.7811299 C4.53842737,14.7130189 4.23500006,14.4380834 4.13039941,14.0719812 L2.30560137,7.68518803 C2.28007524,7.59584656 2.26712532,7.50338343 2.26712532,7.4104669 C2.26712532,6.85818215 2.71484057,6.4104669 3.26712532,6.4104669 L16.9929851,6.4104669 L17.606173,3.78251876 C17.7307772,3.24850086 18.2068633,2.87071314 18.7552257,2.87071314 L20.8200821,2.87071314 C21.4717328,2.87071314 22,3.39898039 22,4.05063106 C22,4.70228173 21.4717328,5.23054898 20.8200821,5.23054898 L19.6915238,5.23054898 L18.1446364,11.84388 Z" fill="#000000" opacity="0.3"></path><path d="M6.5,21 C5.67157288,21 5,20.3284271 5,19.5 C5,18.6715729 5.67157288,18 6.5,18 C7.32842712,18 8,18.6715729 8,19.5 C8,20.3284271 7.32842712,21 6.5,21 Z M15.5,21 C14.6715729,21 14,20.3284271 14,19.5 C14,18.6715729 14.6715729,18 15.5,18 C16.3284271,18 17,18.6715729 17,19.5 C17,20.3284271 16.3284271,21 15.5,21 Z" fill="#000000"></path></g></svg>
										<span>Vahvista</span>
									</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	}
}

export default AddToCart



// WEBPACK FOOTER //
// ./components/addtocart/index.js